import React, { ReactElement, useState } from "react";
import styled from "styled-components";

interface IEditStringInputProps {
  hasError: boolean;
  hasChanged: boolean;
}

export const EditStringInput = styled.input<IEditStringInputProps>`
  background: ${props => props.hasError ? '#ffc0c0' : props.hasChanged ? '#ffffc0' : 'white' };
  font-size: 12px;
  font-family: Segoe UI;
  height: 30px;
  width: 100%;
  padding-left: 10px;
  border-radius: 4px;
  border: 1px solid hsl(0,0%,80%);
`;

export const EditStringTextArea = styled.textarea<IEditStringInputProps>`
  background: ${props => props.hasError ? '#ffc0c0' : props.hasChanged ? '#ffffc0' : 'white' };
  font-size: 12px;
  font-family: Segoe UI;
  width: 100%;
  padding-left: 10px;
  resize: none;
  border-radius: 4px;
  border: 1px solid hsl(0,0%,80%);
  display: block;
`;

interface EditStringBaseProps {
  propertyValue: string;
  hasError: boolean;
  hasChanged: boolean;
  multiLine: boolean;
  onChange: (value: string) => void;
}

export const EditStringProperty = (props: EditStringBaseProps): ReactElement => {
  const [stringValue, setStringValue] = useState(props.propertyValue);

  const onChange = (value: string) => {
    setStringValue(value);
    props.onChange(value);
  };

  if(props.multiLine) {
    return (<EditStringTextArea onChange={(e) => onChange(e.target.value)} hasChanged={props.hasChanged} hasError={props.hasError} value={stringValue ?? ''} ></EditStringTextArea>);
  } else {
    return (<EditStringInput onChange={(e) => onChange(e.target.value)} hasChanged={props.hasChanged} hasError={props.hasError} value={stringValue ?? ''} />);
  }
};
